var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("app-" + _vm.lang), _vm.lang],attrs:{"id":"app"}},[_c('BaseComponent',{attrs:{"isReady":_vm.isShow}},[_c('ContentLoader',{attrs:{"slot":"loader","aegis-first-screen-timing":""},slot:"loader"}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }